// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_8r-4";
export var collapsed = "_8r-1";
export var headerBar = "_8r-0";
export var leftHeaderContent = "_8r-3";
export var subjectContainer = "_8r-2";